import { useState } from 'react';

interface InlineEditFieldProps {
  label: string;
  value: string;
  placeholder?: string;
  onSave: (value: string) => void;
  multiline?: boolean;
}

export default function InlineEditField({
  label,
  value,
  placeholder,
  onSave,
  multiline,
}: InlineEditFieldProps) {
  const [localValue, setLocalValue] = useState(value);
  const [dirty, setDirty] = useState(false);

  const handleChange = (val: string) => {
    setLocalValue(val);
    setDirty(val !== value);
  };

  const handleBlur = () => {
    if (dirty) {
      onSave(localValue);
      setDirty(false);
    }
  };

  const inputClass =
    'w-full bg-transparent border border-transparent rounded px-2 py-1 text-sm text-gray-900 ' +
    'hover:border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none transition-colors';

  return (
    <div className="py-3 sm:grid sm:grid-cols-3 sm:gap-4">
      <dt className="text-sm font-medium text-gray-500">{label}</dt>
      <dd className="mt-1 sm:mt-0 sm:col-span-2">
        {multiline ? (
          <textarea
            value={localValue}
            onChange={e => handleChange(e.target.value)}
            onBlur={handleBlur}
            placeholder={placeholder}
            rows={2}
            className={`${inputClass} resize-none`}
          />
        ) : (
          <input
            value={localValue}
            onChange={e => handleChange(e.target.value)}
            onBlur={handleBlur}
            placeholder={placeholder}
            className={inputClass}
          />
        )}
      </dd>
    </div>
  );
}
